import type { TFunction } from 'i18next';
import { isApiError, type ArticleListItem } from '@shared/api';

export function articleErrorKey(error: unknown) {
  if (!isApiError(error)) return 'articles.errors.failed';
  switch (error.status) {
    case 401:
      return 'articles.errors.signedOut';
    case 403:
      return 'articles.errors.denied';
    case 404:
      return 'articles.errors.notFound';
    case 409:
      return 'articles.errors.conflict';
    case 412:
      return 'articles.errors.stale';
    case 428:
      return 'articles.errors.validator';
    case 400:
      return 'articles.errors.invalid';
    default:
      return 'articles.errors.failed';
  }
}

export function articleStatusLabel(status: string | null, t: TFunction) {
  return status === 'Draft' || status === 'Approved'
    ? t(`articles.status.${status}`)
    : status || t('crm.missingValue');
}

export function articleTopicLabel(topic: ArticleListItem['topic'], t: TFunction) {
  if (!topic) return t('crm.missingValue');
  // The current catalogue retains source keys; migrated catalogues may expose display values.
  if (topic.dbValue === 'customer_support' || topic.dbValue === 'customer-support')
    return t('articles.topics.customer_support');
  if (topic.dbValue === 'gear' || topic.dbValue === 'Gear') return t('articles.topics.gear');
  return topic.display;
}

/** An ambiguous transport result must retain the identical request identity and body. */
export function articleOutcomeUnknown(error: unknown) {
  return (
    !isApiError(error) ||
    error.status === 0 ||
    error.status >= 500 ||
    ['PARSE_ERROR', 'ABORTED', 'VALIDATION_ERROR'].includes(error.code)
  );
}
